import { connect } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { toggleCommissionStatus } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';
import {
  getIsDeleted,
  getIsActive,
} from '@wix/da-shared-react/pkg/redux/commissions/selectors';
import {
  editDeviation,
  deleteDeviation,
} from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';

import { isCurrentUserProfileOwner } from '../../../../../selectors/users';

export default connect(
  (state: AppState, ownProps) => ({
    isOwner: isCurrentUserProfileOwner(state),
    isDeleted: getIsDeleted(state, ownProps.deviation.deviationId),
    isActive: getIsActive(state, ownProps.deviation.deviationId),
  }),

  { toggleCommissionStatus, editDeviation, deleteDeviation }
);
